import { StyleVersionTag } from 'containers/AppContainer/style';

const VersionTag = () => {
  return (
    <div style={{ ...StyleVersionTag, position: 'fixed' }}>
      {process.env.REACT_APP_VERSION}
    </div>
  );
};

export default VersionTag;
